// extracted by mini-css-extract-plugin
module.exports = {"bodyMerchOpen":"MerchBanners_bodyMerchOpen__3lf2Y","merchBanners":"MerchBanners_merchBanners__hPczz","bannerItem":"MerchBanners_bannerItem__2Bi29"};